// @flow strict
import * as React from 'react'
import { useState } from 'react'

import styles from './Input.module.scss'

export type Props = {
  name: string,
  label: string,
  type?: string,
  children?: string,
  required?: boolean,
  pattern?: string,
  onChangeHandler?: (value: string | boolean) => mixed,
  pattern?: string,
  placeholder?: string,
}

const Input = (props: Props) => {
  const {
    children = '',
    type = 'text',
    name,
    label,
    required,
    onChangeHandler,
    pattern,
    placeholder,
  } = props
  const [isFocused, setIsFocused] = useState(false)
  const [value, setValue] = useState(children)
  const toggleIsFocused = () => setIsFocused(!isFocused)
  const onChange = (evt: SyntheticEvent<HTMLInputElement>) => {
    const value = evt.currentTarget && evt.currentTarget.value
    setValue(value)
    if (type === 'checkbox') {
      onChangeHandler &&
        onChangeHandler(evt.currentTarget && evt.currentTarget.checked)
    } else {
      onChangeHandler && onChangeHandler(value)
    }
  }

  return (
    <div
      className={type === 'checkbox' ? styles.checkboxWrapper : styles.wrapper}
    >
      <label htmlFor={name} className={styles.label}>
        {label}
        {required && <span className={styles.required}> *</span>}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        required={required}
        onFocus={toggleIsFocused}
        onBlur={toggleIsFocused}
        onChange={onChange}
        className={styles.input}
        defaultValue={value}
        pattern={pattern}
        placeholder={placeholder}
      />
    </div>
  )
}

export default Input
